module.exports = __webpack_public_path__ + "media/images/c-form-6854ca08220234d2a856e28082886a19.png";